import { render, staticRenderFns } from "./photov2.vue?vue&type=template&id=c8951a5a&scoped=true&"
import script from "./photov2.vue?vue&type=script&lang=js&"
export * from "./photov2.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./photov2.vue?vue&type=style&index=0&id=c8951a5a&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c8951a5a",
  "5a9f5de6"
  
)

export default component.exports